<template>
  <div class="vhp-stepper">
    <div 
      class="vhp-stepper-item"
      v-for="(item, idx) in items"
      :key="'vsi-' + idx"
      
      data-aos-duration="500"
      :data-aos-delay="idx * 200"
      data-aos-offset="100"
      data-aos="fade-right"
      data-aos-easing="ease-in-out"
    >
      <div class="step">
        <h3>{{(idx.toString().length === 1 ? '0' : '')  + (idx + 1)}}</h3>

        <div class="title">
          {{item.title}}
        </div>
      </div>

      
      <slot class="content" name="content"></slot>
      <div class="content" v-if="!$slots.content">
        {{item.content}}
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
    props:{
      items:{
        type: Array,
        default: () => []
      }
    },
    data() {
        return {
        }
    },
    methods:{
    }

}
</script>

<style lang="scss" src="./vhpStepper.scss"></style>